module.exports = __webpack_public_path__ + "img/credit-card.1ee8980b.png";